import React from 'react';
import VideoJs from './VideoJs';
import Title from "../Title"
import { isMobileOnly, useMobileOrientation } from 'react-device-detect';
import { Box, useMediaQuery, useTheme } from '@mui/material'

export default function Timelapse(props) {
    
    const { breakpoints } = useTheme();
    const { contentHeight, camera } = props
    const { isLandscape } = useMobileOrientation()
    
    const camCount = window.conf.CAMERAS.length
    const manyCams = camCount > window.conf.LAYOUT.WRAP_LIMIT
    const isXl = useMediaQuery(breakpoints.up('xl'))

    return (
        <Box 
            sx={{
                display: "flex",
                alignContent: 'center',
                justifyContent: "center",
                position: "relative"
            }} 
        >
            <Title cameraName={camera.name} />
            <Box 
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 
                        isMobileOnly
                        ? isLandscape
                            ? contentHeight
                            : camCount < 2
                                ? contentHeight
                                : camCount < 3
                                    ? contentHeight / 2
                                    : 'unset'
                        : manyCams
                            ? 'unset'
                            : isXl && camCount > 2
                                ? contentHeight/Math.ceil(camCount/3)
                                : contentHeight/Math.ceil(camCount/2),
                    width: "100%",
                    border: "none"
                }}
                className={
                    isMobileOnly
                    ? ''
                    : camCount < 2
                        ? 'heightWithoutHeader'
                        : camCount === 2
                            ? 'halfHeightWithoutHeader'
                            : 'unsetHeight'
                }
            >
                <VideoJs camera={camera} />
            </Box>
        </Box>
    )
}